import {
  AdminLoadCurrentOrganizationConfig,
  AdminCreateOrganizationConfig,
  AdminSetCurrentOrganizationConfig,
  AdminDeleteOrganizationConfig,
  AdminSetOrganizationConfigError,
  AdminRemoveOrganizationConfigError,
} from './admin-organization-config.actions';
import { AdminOrganizationConfig } from 'src/app/admin/models/organization.model';
import { AdminOrganizationConfigApiError } from './admin-organization-config.errors';
import { createReducer, on } from '@ngrx/store';

export interface AdminOrganizationConfigState {
  currentOrganizationConfig: AdminOrganizationConfig;
  apiError: AdminOrganizationConfigApiError;
  loading: boolean;
}

const initialState: AdminOrganizationConfigState = {
  currentOrganizationConfig: null,
  apiError: null,
  loading: false,
};

export const adminOrganizationConfigReducer = createReducer(
  initialState,
  on(AdminLoadCurrentOrganizationConfig, (state) => ({ ...state, apiError: null, loading: true })),
  on(AdminCreateOrganizationConfig, (state) => ({ ...state, apiError: null, loading: true })),
  on(AdminSetCurrentOrganizationConfig, (state, { config }) => ({
    ...state,
    apiError: null,
    loading: false,
    currentOrganizationConfig: config,
  })),
  on(AdminDeleteOrganizationConfig, (state) => ({ ...state, apiError: null, loading: true })),
  on(AdminSetOrganizationConfigError, (state, { error }) => ({
    ...state,
    apiError: error,
    loading: false,
  })),
  on(AdminRemoveOrganizationConfigError, (state) => ({ ...state, apiError: null, loading: false })),
);
